// Reposiory of app-wide domain events

export default AppEvents = {
    APP_VERSION_UPDATED: 'app_version_updated',

    LOGIN_NEEDED: 'login_needed',
    LOGIN: 'login',
    LOGOUT: 'logout',
    NEEDS_LOGOUT: 'needs_logout',
    USER_LOADED: 'user_loaded', // after silent auth, etc.

    API_ERROR: 'api_error',
    PROVIDER_API_ERROR: 'provider_api_error',

    DATA_LOADED: 'data_loaded',
    DATA_RECALCULATED: 'data_recalculated',

    DATA_SET_LOADED: 'data_set_loaded', // defunct
    DATA_SET_RECALCULATED: 'data_set_recalculated',
    DATA_MODULE_RECALCULATED: 'data_module_recalculated',
    DATA_SOURCES_CHANGED: 'data_sources_changed', // if there's an update to an already loaded/ready data set, for a component.
    DATA_SOURCE_SAVED: 'data_source_saved',
    DATA_SOURCE_REMOVED: 'data_sources_removed',

    SHOW_NAV_MENU: 'show_nav_menu',

    PROVIDER_PROGRESS_UPDATE: 'provider_progress_update',

    DATE_KEYS_CHANGED: 'DATE_KEYS_CHANGED',

    PROVIDER_ACCOUNT_CHANGED: 'PROVIDER_ACCOUNT_CHANGED', // provider account connected/disconnected (ie. trigger update)

    NETWORK_NOT_REACHABLE: 'NETWORK_NOT_REACHABLE',

    ACCOUNT_UPDATED: 'ACCOUNT_UPDATED',
    CHANGE_ACCOUNT: 'CHANGE_ACCOUNT',
};